module.exports = __webpack_public_path__ + "static/img/example2.70dd0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/example2.jpg
// module id = KNpX
// module chunks = 1